import "./ResetPassword.css";

import logo from "../../assests/bunnyMoni.jpg";

const ResetSuccess: React.FC = () => {
  return (
    <div className="container">
      <div className="card">
        <img className="logo" src={logo} alt="hobsavings logo" />
        <h1 className="title">password reset successfully</h1>
      </div>
    </div>
  );
};

export default ResetSuccess;
